import axios from 'axios';
import {getToken} from '../utils/Auth';

// const API_BLOG_BASE_URL = 'https://localhost:7137/api/life';
// const API_BASE_URL = 'https://localhost:7137/api/stemcellsoft';
const API_BLOG_BASE_URL = 'https://mulproject2-cxg8bcb5abhbgaf0.westus2-01.azurewebsites.net/api/life';
const API_BASE_URL = 'https://mulproject2-cxg8bcb5abhbgaf0.westus2-01.azurewebsites.net/api/stemcellsoft';

axios.defaults.headers.common["Authorization"] = `Bearer ${getToken()}`;

export const getOrSetZkLoginSalt = async (data) => {
  try {

    //161751108297110060482196097209305487943
    //152211142186577158431604343075817260344
    return {salt: '161751108297110060482196097209305487943'}; // mock
    
    // const response = await axios.post(`${API_BASE_URL}/User/zk-login`, data, { timeout: 60000 });
    // return response.data; // 返回資料
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const mintTwentyTokenApiAsync = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`${API_BASE_URL}/Blockchain/sui/twenty/mint-token`, data);
    return response.data; // 返回資料
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const getBlockchainOptionApiAsync = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/blockchain/sui/2048`);
    return response.data; // 返回資料
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const executeSponsorAndZkUserTxApiAsync = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/blockchain/sui/2048`, data);
    return response.data; // 返回資料
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const loginApiAsync = async (data) => {
  try {
    const response = await axios.post(`${API_BLOG_BASE_URL}/jlIf1?n=${data.n}&p=${data.p}`);

    return response.data; // 返回資料
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const postListApiAsync = async (si,ci) => {
  try {
      const response = await axios.get(`${API_BLOG_BASE_URL}/post-list/get`,{
        params: {
          si: si,
          ci: ci,
        },
      });

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const postApiAsync = async (data) => {
  try {
      const response = await axios.get(`${API_BLOG_BASE_URL}/post/get`,{
        params: {
          shortPostId: data,
        },
      });

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const categoryListApiAsync = async () => {
  try {
      const response = await axios.get(`${API_BLOG_BASE_URL}/category-list/get`);

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const latelyPostListApiAsync = async () => {
  try {
      const response = await axios.get(`${API_BLOG_BASE_URL}/lately-post-list/get`);

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const postImageApiAsync = async (data) => {
  try {
      const response = await axios.post(`${API_BLOG_BASE_URL}/image/upload-test`,data);

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const createPostApiAsync = async (data) => {
  try {
      console.log(data);
      const response = await axios.post(`${API_BLOG_BASE_URL}/post/create`,data);

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const updatePostApiAsync = async (data) => {
  try {
      console.log(data);
      const response = await axios.post(`${API_BLOG_BASE_URL}/post/update`,data);

      return response.data; // 返回資料
  } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
  }
};

export const getBlockchainContractConfigApiAsync = async () => {
  try {
      const response = await axios.get(`${API_BASE_URL}/Blockchain/blockchain/sui/2048`);
      return response.data; // 返回合約設定資料
  } catch (error) {
      console.error('Error fetching blockchain contract config:', error);
      throw error;
  }
};